import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-00615d4a")

_pushScopeId("data-v-00615d4a")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "columns" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "column" }, [
  /*#__PURE__*/_createVNode("h1", { class: "title" }, "Monthly availability")
], -1)
const _hoisted_5 = { class: "column is-narrow" }
const _hoisted_6 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "monthly-wrap" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_teams_dropdown = _resolveComponent("teams-dropdown")
  const _component_team_monthly_calendar = _resolveComponent("team-monthly-calendar")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_teams_dropdown)
          ])
        ]),
        _hoisted_6,
        _createVNode(_component_team_monthly_calendar)
      ])
    ]),
    _hoisted_7
  ]))
})